import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { api } from '../../shared/utils/api';
import StringUtils from '../../conversations/utils/string';
import { handleAvatarMerge, parseNames } from '../utils/messenger_utils';
import { MARK_CONVERSATION_AS_READ } from '../reducers/messenger_reducers';

const ConversationIndexCard = ({
  conversation,
  handleNewConversationWindow,
  unreadMessageCount,
  orderedNames,
  day,
  mostRecentMessage,
  avatars,
  id,
  handleTotalUnreadCount,
  handleConversationList,
  show
}) => {
  const [openWindow, setOpenWindow] = useState(false);

  useEffect(() => {
    if (openWindow) {
      handleNewConversationWindow(conversation);
    }
    setOpenWindow(false);
  }, [conversation])

  const handleRead = () => {
    if (unreadMessageCount > 0) {
      api.put(`messenger/read`, { conversation_id: id }, { baseURL: '/' })
    }
  }

  const handleCountResetUI = () => {
    handleTotalUnreadCount((prevtotalUnreadCount) => prevtotalUnreadCount - unreadMessageCount);
    handleConversationList({ type: MARK_CONVERSATION_AS_READ, conversationState: conversation });
  }

  const handleClick = () => {
    handleCountResetUI();
    handleRead();
    setOpenWindow(true);
  }

  const time = StringUtils.formatTimestampMessengerWindows(day)

  return (
    <>
    { show &&
      <div
        className="message-card display-flex pointer"
        onClick={handleClick}
      >
        {avatars.length > 1 && <div className="avatar-group-container">{handleAvatarMerge(avatars)}</div>}
        {avatars.length === 1 && <img src={avatars[0]} className="avatar" />}
        {unreadMessageCount >= 1 && (
          <div className="badge-avatar">
            <span>{unreadMessageCount}</span>
          </div>
        )}
        <div className="ml-10 pb-5 message-card-info">
          <div className="display-flex justify-between">
            <h4 className="message-card-name index">
              {parseNames(orderedNames)}
            </h4>
            <span className="date-time">{time}</span>
          </div>
          <div className="display-flex align-left">
            <p className={`m-0 message ${unreadMessageCount >= 1 ? 'w3' : ''}`}>{mostRecentMessage}</p>
          </div>
        </div>
      </div>
    }
    </>
  );
};

ConversationIndexCard.propTypes = {
  conversation: PropTypes.object.isRequired,
  handleNewConversationWindow: PropTypes.func.isRequired
};

export default ConversationIndexCard;
